import { inject, Injectable } from '@angular/core';
import { Service, ServiceCodes } from '@checkout-v2/const';
import { Store } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { Observable } from 'rxjs/internal/Observable';
import { CheckoutActions, CheckoutSelectors, StateWithCustomCheckout } from '../store';

@Injectable({
  providedIn: 'root',
})
export class ServicesFacade {
  private readonly store = inject(Store<StateWithCustomCheckout>);

  getServicesState(): Observable<StateUtils.LoaderState<Service[]>> {
    return this.store.select(CheckoutSelectors.getServicesState);
  }

  getServices(): Observable<Service[]> {
    return this.store.select(CheckoutSelectors.getServices);
  }

  getServicesLoading(): Observable<boolean> {
    return this.store.select(CheckoutSelectors.getServicesLoading);
  }

  getServicesError(): Observable<boolean> {
    return this.store.select(CheckoutSelectors.getServicesError);
  }

  getServicesSuccess(): Observable<boolean> {
    return this.store.select(CheckoutSelectors.getServicesSuccess);
  }

  getServicesActiveOptionCode(): Observable<ServiceCodes | undefined> {
    return this.store.select(CheckoutSelectors.getSelectedServiceId);
  }

  getServicesActiveOption(): Observable<Service | undefined> {
    return this.store.select(CheckoutSelectors.getSelectedService);
  }

  setServicesActiveOption(code: ServiceCodes | undefined): void {
    this.store.dispatch(new CheckoutActions.SelectServicesActiveOption(code));
  }
}
